import React from 'react';


const LockerDetailsComponent = ({ locker, variant = 'default', onBook }) => {
  // Default values if locker data is not provided
  const {
    name = "Storage Spot",
    address = "Address will be shown after booking",
    city = "",
    price = "₹30/hr",
    backgroundImage = "https://via.placeholder.com/400x200/2196f3/ffffff?text=Storage+Spot",
    logoImage = "",
    available = 0,
    distance = "",
    description = "",
    lockerNumber = ""
  } = locker || {};

  // Format price display
  const formatPrice = (priceStr) => {
    if (!priceStr) return "From $2.95 / day";
    return `From ${priceStr}`;
  };

  // Get location string
  const getLocation = () => {
    if (address && city) return `${address}, ${city}`;
    if (address) return address;
    if (city) return city;
    return "Location available after booking";
  };

  return (
    <div className={`storage-card storage-card--${variant}`}>
      {/* Image Section */}
      <div className="storage-card__image-container">
        <img 
          src={backgroundImage}
          alt={name}
          className="storage-card__image"
          onError={(e) => {
            e.target.src = "https://via.placeholder.com/400x200/2196f3/ffffff?text=Storage+Spot";
          }}
        />
        {available > 0 && (
          <div className="storage-card__image-badge">
            <span className="storage-card__image-badge-text">{available} spots left</span>
          </div>
        )}
      </div>

      {/* Content Section */}
      <div className="storage-card__content">
        <div className="storage-card__header">
          <h2 className="storage-card__title">{name}</h2>
          
          <div className="storage-card__badge-container">
            <span className="storage-card__badge storage-card__badge--open">Open 24h</span>
            {distance && (
              <span className="storage-card__badge storage-card__badge--distance">{distance} km</span>
            )}
          </div>
          
          <div className="storage-card__info-line">
            <span className="storage-card__everyday">Every day</span>
            {lockerNumber && (
              <span className="storage-card__locker">Locker # {lockerNumber}</span>
            )}
          </div>
        </div>

        {description && (
          <div className="storage-card__description">
            <p>{description}</p>
          </div>
        )}

        <div className="storage-card__address-section">
          <p className="storage-card__address-label">
            <span className="storage-card__address-icon">📍</span>
            {getLocation()}
          </p>
          <div className="storage-card__divider"></div>
        </div>

        <div className="storage-card__hours">
          <h3 className="storage-card__subtitle">Opening hours</h3>
          <p className="storage-card__hours-text">Open 24 hours · Every day</p>
        </div>

        <div className="storage-card__includes">
          <h3 className="storage-card__subtitle">Your online booking includes</h3>
          
          <div className="storage-card__feature">
            <span className="storage-card__feature-icon">✓</span>
            <div className="storage-card__feature-content">
              <strong>Free cancellation</strong>
              <p>Cancel anytime before drop off for a refund.</p>
            </div>
          </div>

          <div className="storage-card__feature">
            <span className="storage-card__feature-icon">🛡️</span>
            <div className="storage-card__feature-content">
              <strong>Bag protection</strong>
              <p>Peace of mind knowing you've got $10,000 coverage for each bag.</p>
            </div>
          </div>

          <div className="storage-card__feature">
            <span className="storage-card__feature-icon">💬</span>
            <div className="storage-card__feature-content">
              <strong>24/7 support</strong>
              <p>Dedicated support team ready to assist you. We typically reply in 15 minutes.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer with Price and Button */}
      <div className="storage-card__footer">
        <div className="storage-card__price-section">
          <div className="storage-card__price">
            {formatPrice(price)}/24 hours
          </div>
          <button className="storage-card__button" onClick={onBook}>
            Book this store
          </button>
        </div>
      </div>
    </div>
  );
};

export default LockerDetailsComponent;